import path from 'path'
import mapValues from 'lodash/mapValues'

export const PageHeaderRoutes = {
  data() {
    return {
      isShowingMainMenu: false
    }
  },

  computed: {
    mainMenuLabel() {
      return this.isShowingMainMenu ? 'Close Main Menu' : 'Open Main Menu'
    },

    routes() {
      const list = {
        ai: {
          location: { name: `ai` },
          options: {}
        },
        account: {
          location: { name: `account` },
          options: { last: true }
        },
        signIn: {
          location: {
            name: 'sessions.sign-in',
            query: { next: path.join(this.$router.options.history.base, this.$route.fullPath) }
          },
          options: {}
        },
        docs: {
          // Pass a login hint to the docs site (docs.fontawesome.com) so it can mirror
          // the logged-in/out header without sharing any session or credentials.
          // 1 = logged in, 0 = logged out. Centralized here so every docs link (header +
          // responsive drawer) carries it.
          location: {
            name: `latest.docs`,
            params: { pathMatch: [] },
            query: { fa_session: this.$account ? '1' : '0' }
          },
          options: {}
        },
        icons: {
          location: { name: `latest.icons` },
          options: {}
        },
        iconwizard: {
          location: { name: `iconwizard` },
          options: {}
        },
        kits: {
          location: { name: `kits` },
          options: {}
        },
        plans: {
          location: { name: `plans` },
          options: {}
        },
        search: {
          location: { name: 'latest.search' },
          options: {}
        },
        start: {
          location: { name: `start` },
          options: {}
        },
        support: {
          location: { name: `support` },
          options: {}
        }
      }

      return mapValues(list, (item) => {
        const { location, options } = item
        let active = (this.$route.name || '').indexOf(location.name) === 0

        if (this.$router.options.history.base === '/docs' && location.name === 'latest.docs') {
          active = true
        }

        return {
          location,
          active,
          options
        }
      })
    }
  },

  methods: {
    toggleMainMenu() {
      this.isShowingMainMenu = !this.isShowingMainMenu
    }
  }
}
